import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const title = "Contact JTB Floors | Free Flooring Estimate, Barrington";
const description =
  "Get a free flooring estimate from JTB Floors. Call (773) 934-2004 or send us your project details. Serving Barrington, IL and a 35-mile radius.";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/contact` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/contact` }],
    scripts: [breadcrumbLd("Contact", "/contact"), webPageLd("ContactPage", title, description, "/contact")],
  }),
  component: Contact,
});
